import type { TConversation, TMessage } from '@stores/chat-domain.types';
import { CHAT_CONVERSATION_TYPES, DEFAULT_TAGS } from '@/utils/constants';

/**
 * Resolve as tags do refetch preservando o filtro ativo. Sem isso o backend
 * devolve a lista 'to' inteira (incl. Spam/Blocked) e as conversas spam vazam
 * para o filtro atual. Vale para os dois gatilhos (nova mensagem e não-lida). ANCR-5348.
 */
export const resolveActiveTags = (chatType: string, selectedTags: string[]): string[] | null => {
	if (selectedTags.length > 0) return selectedTags;
	const isSale = chatType.toLowerCase() === CHAT_CONVERSATION_TYPES.sale;
	return isSale ? DEFAULT_TAGS : null;
};

const updateConversationMessage = (conversation: TConversation, messageSource: TMessage): TConversation => ({
	...conversation,
	message: {
		...conversation.message,
		message: messageSource.message,
		sentOn: new Date(messageSource.sentOn).toString(),
		senderId: messageSource.senderId,
	},
});

/** Atualiza ou cria uma conversa na lista com a última mensagem recebida, reposicionando-a no topo. */
export const insertConversationMessage = ({
	source,
	chatId,
	messageSource,
}: {
	source?: TConversation[];
	chatId?: string;
	messageSource?: TMessage[];
} = {}): TConversation[] | undefined => {
	if (!source?.length || !chatId || !messageSource?.length) return source;

	const lastMessage = messageSource[messageSource.length - 1];
	const existingIndex = source.findIndex(conversation => conversation.chatId === chatId);

	if (existingIndex === -1) {
		const newConversation = updateConversationMessage({ message: {} } as TConversation, lastMessage);
		return [{ ...newConversation, chatId }, ...source];
	}

	const updated = updateConversationMessage(source[existingIndex], lastMessage);
	return [updated, ...source.filter((_, i) => i !== existingIndex)];
};
